<template>
  <div class="c-picture-uploader">
    <div class="c-picture-uploader__label" v-if="label">{{ label }}</div>
    <o-icon class="c-picture-uploader__icon" icon="camera" v-if="!image" />
    <div
      class="c-picture-uploader__preview"
      :style="{ backgroundImage: `url('${$store.state.baseUrl}${image}')` }"
      v-if="image"
    />
  </div>
</template>

<script>
export default {
  name: 'OPictureUploader',
  props: {
    image: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss">
.c-picture-uploader {
  background: #fff;
  border: 0.1rem solid rgba($primary-color, 0.2);
  border-radius: 0.8rem;
  box-shadow: $box-shadow-list;
  cursor: pointer;
  height: 13.6rem;
  margin: 2.4rem auto;
  position: relative;
  width: 21.2rem;
}

.c-picture-uploader__label {
  background: $background-color;
  border-radius: 0 0 0.4rem 0.4rem;
  color: $primary-color;
  color: var(--primary-color);
  font-size: 1rem;
  font-weight: 600;
  left: 50%;
  padding: 0.2rem 0.6rem;
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  text-transform: uppercase;
  z-index: 2;
}

.c-picture-uploader__icon {
  color: $primary-color;
  color: var(--primary-color);
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}

.c-picture-uploader__preview {
  background-size: cover;
  border-radius: 0.4rem;
  bottom: 0.4rem;
  left: 0.4rem;
  position: absolute;
  right: 0.4rem;
  top: 0.4rem;
}
</style>
